<template>
  <div class="exam-bank container">
    <div class="box">
      <el-page-header @back="$router.go(-1)" content="试卷库"> </el-page-header>
      <el-form :model="params" class="search_form" :inline="true" size="small">
        <el-form-item prop="title">
          <el-input v-model="params.title" placeholder="搜索"
            ><el-button
              slot="append"
              size="small"
              icon="el-icon-search"
              @click="getList"
            ></el-button
          ></el-input>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            type="danger"
            size="small"
            @click="handleDelBatch"
            v-show="selectedIds.length != 0"
            >批量删除</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="showSetType = true"
            >新建考试</el-button
          ></el-form-item
        >
      </el-form>

      <el-table
        class="bank-list"
        :data="list"
        stripe
        @selection-change="handleSelectionChange"
        row-key="examId"
        lazy
        :load="loadChildren"
        :tree-props="{ hasChildren: 'random' }"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="(row) => !row.hideBtn"
        >
        </el-table-column>
        <el-table-column prop="title" label="考试">
          <template slot-scope="scope">
            <span
              style="cursor: pointer"
              @click="
                scope.row.random ||
                  $router.push({
                    path: '/classCourse/exam/detail',
                    query: {
                      ...$route.query,
                      examId: scope.row.examId,
                    },
                  })
              "
              >{{ scope.row.title }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          :formatter="formatter"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="left">
          <template slot-scope="scope">
            <el-button
              @click="handelRelease(scope.row.examId, scope.row.title)"
              type="primary"
              size="small"
              round
              v-show="!scope.row.hideBtn"
              >发布</el-button
            >
            <el-button
              @click="handelEdit(scope.row.examId)"
              type="text"
              size="small"
              v-show="!scope.row.random"
              >编辑</el-button
            >
            <el-button
              @click="handelExport(scope.row.examId)"
              type="text"
              size="small"
              v-show="!scope.row.random"
              >导出</el-button
            >
            <el-button
              @click="handleDel(scope.row.examId)"
              type="text"
              size="small"
              v-show="!scope.row.hideBtn"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="foot_page">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :page-size="params.limit"
          :current-page.sync="params.page"
          :total="total"
          @current-change="getList"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="新建考试" :visible.sync="showSetType" width="30%" center>
      <div style="margin-bottom: 20px">
        <el-radio v-model="isAuto" :label="false">手动创建试卷</el-radio>
        <p style="padding-left: 15px; font-size: 12px; color: #909399">
          （手动编辑创建新试卷）
        </p>
      </div>
      <div>
        <el-radio v-model="isAuto" :label="true">自动随机组卷</el-radio>
        <p style="padding-left: 15px; font-size: 12px; color: #909399">
          （系统从已有题库中随机选题组卷）
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="showSetType = false">取 消</el-button>
        <el-button type="primary" size="medium" @click="handleSet"
          >下一步</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { examList, delExam, randomList } from "@/api/exam";
import { formatDate } from "@/utils/index";

export default {
  data() {
    return {
      params: {
        page: 1,
        limit: 7,
        classId: this.$route.query.id,
        title: "",
      },
      total: 2,
      list: [],
      selectedIds: [],
      showSetType: false,
      isAuto: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      this.$loading.show();
      examList(this.params).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.list = data.records;
          this.total = data.total;
        } else {
          this.$message.error(msg);
        }
      });
    },
    loadChildren(tree, treeNode, resolve) {
      randomList(tree.examId).then((res) => {
        if (res.code == 0) {
          resolve(
            res.data.map((item) => ({ ...item, random: false, hideBtn: true }))
          );
        }
      });
    },
    // 格式化时间
    formatter(row) {
      return formatDate(row.createTime, "YYYY-MM-DD HH:mm:ss");
    },
    // 发布
    handelRelease(examId, examTitle) {
      this.$router.push({
        path: "/classCourse/exam/settings",
        query: {
          ...this.$route.query,
          examId,
          examTitle,
        },
      });
    },
    // 编辑
    handelEdit(examId) {
      this.$router.push({
        path: "/classCourse/exam/setExam",
        query: {
          ...this.$route.query,
          examId,
        },
      });
    },
    // 导出
    handelExport(examId) {
      let token = localStorage.getItem("token");
      window.open(
        `${process.env.VUE_APP_API_DOMAIN}/app/teacher/exam/${examId}/export?Authorization=${token}`
      );
    },
    // 删除
    handleDel(examId) {
      this.$confirm("确定要删除试卷吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delExam(examId).then(({ code, msg }) => {
            this.$loading.hide();
            if (code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(msg);
            }
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(selection) {
      selection = selection.filter((t) => {
        return !t.hideBtn;
      });
      this.selectedIds = selection.map((item) => item.examId);
    },
    handleDelBatch() {
      this.handleDel(this.selectedIds);
    },
    // 点击新建
    handleSet() {
      if (this.isAuto)
        this.$router.push({
          path: "/classCourse/exam/autoSetExam",
          query: { ...this.$route.query },
        });
      else
        this.$router.push({
          path: "/classCourse/exam/setExam",
          query: { ...this.$route.query },
        });
    },
  },
};
</script>

<style lang="less" scoped>
.exam-bank {
  height: 100%;
  text-align: left;

  .box {
    padding: 25px 35px;
    background-color: #fff;
    ::v-deep .el-page-header {
      .el-page-header__content {
        font-size: 16px;
      }
    }
    ::v-deep .search_form {
      margin-top: 20px;
      .el-form-item {
        margin-right: 50px;
        .el-input-group__append {
          background-color: teal;
          border-color: teal;
          color: #fff;
        }
      }
    }
    ::v-deep .bank-list {
      .is-leaf {
        color: #333;
        background-color: #f5f5f5;
      }
    }

    ::v-deep .foot_page {
      margin-top: 20px;
      text-align: right;
      .el-pagination__total {
        float: left;
      }
    }
  }
}
</style>